import { isBrowser } from '../helpers'
import { query, saveUser } from './utilities'
import { API_URL } from '../constants/config'
import * as mockService from './mockService'

export const getUser = () =>
  isBrowser() && window.localStorage && window.localStorage.getItem('mmsgUser')
    ? JSON.parse(window.localStorage.getItem('mmsgUser'))
    : {}

export const isLoggedIn = () => {
  //return true;
  const user = getUser()
  return !!user.token
}

export const logout = () => {
  localStorage.removeItem('mmsgUser')
}

export const validateAccessCode = (opportunityId, accessCode, token) =>
  query(`${API_URL}/Auth/oly`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ opportunityId, accessCode, token }),
  }).then((user) => {
    if (user.token) {
      const result = {
        token: user.token,
        opportunityId,
        expiresIn: user.expiresIn,
        isAtSettlement: user.isAtSettlement,
      }
      saveUser(result) //save token in local storage
      return result
    } else {
      return Promise.reject('bad response token')
    }
  })

export const requestAccessCode = (
  opportunityId,
  authenticationMethod,
  token
) => {
  var inputDetails = {
    token: token,
  }

  return query(
    `${API_URL}/Auth/${opportunityId}/${authenticationMethod}/oly`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(inputDetails),
    }
  )
}
